import { AppBar } from '@farmersdog/corgi';

import config from '../../config';

import { DiscountBanner } from './DiscountBanner';
import styles from './Navigation.css';
import { useItems } from './useItems';

export function Navigation() {
  const items = useItems();
  const websiteUrl = config.get('app.websiteUrl');

  return (
    <>
      <DiscountBanner />
      <div className={styles.large}>
        <AppBar
          large={true}
          logoHref={websiteUrl}
          darkTheme
          hasContentAbove
          {...items}
        />
      </div>
      <div className={styles.small}>
        <AppBar
          large={false}
          logoHref={websiteUrl}
          darkTheme
          hasContentAbove
          {...items}
        />
      </div>
    </>
  );
}
